import * as Yup from "yup";
import "yup-phone";
import { format, getYear } from "date-fns";
import { fDateTime } from "./minimal/formatTime";
import { matchIsValidTel } from "mui-tel-input"

// Yup is throwing n error when validation failed... this is why the try catch blocks

export const isValidEmail = (email) => {
    try {
        email = email ? email.trim().toLowerCase() : ''
        if (!email) {
            return false
        }
        const emailSchema = Yup.string().email();
        emailSchema.validateSync(email)
        return true
    } catch (e) {
        return false
    }
}

export const isValidPhone = (phone) => {
    try {
        return matchIsValidTel(phone)
    } catch (e) {
        return false
    }
}

export const isValidSocialLink = (link) => {
    // More complex validation can comes here
    link = link ? link.trim().toLowerCase() : ''
    if (!link) {
        return false
    }
    const isFacebook = link.toLowerCase().includes('facebook')
    const isInstagram = link.toLowerCase().includes('instagram')
    return (isFacebook || isInstagram)
}

export const isValidBirthDate = (date, minAgeAllow) => {
    try {
        const d = new Date(date)
        const yearChars = String(d.getFullYear()).length
        return yearChars === 4
    } catch (e) {
        return false
    }
}

// Handler must be in english and contain no '/' to not break the url.
export const validateHandler = (handler) => {
    const pattern = /^[A-Za-z0-9-_]+$/
    return pattern.test(handler)
}

export const isValidDate = (date) => {
    return date && !isNaN(new Date(date).getTime());
}
